import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls", "size", "className"];
import classNames from "classnames";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import warning from "../hack/_util/warning";
import { jsx as _jsx } from "react/jsx-runtime";
export var GroupSizeContext = /*#__PURE__*/React.createContext(undefined);
var ButtonGroup = function ButtonGroup(props) {
  var _classNames;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var customizePrefixCls = props.prefixCls,
    size = props.size,
    className = props.className,
    others = _objectWithoutProperties(props, _excluded);
  var prefixCls = getPrefixCls("btn-group", customizePrefixCls);

  // large => lg
  // small => sm
  var sizeCls = "";
  switch (size) {
    case "large":
      sizeCls = "lg";
      break;
    case "small":
      sizeCls = "sm";
      break;
    case "middle":
    case undefined:
      break;
    default:
      warning(!size, "Button.Group", "Invalid prop `size`.");
  }
  var classes = classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
  return /*#__PURE__*/_jsx(GroupSizeContext.Provider, {
    value: size,
    children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, others), {}, {
      className: classes
    }))
  });
};
export default ButtonGroup;